import { Link } from "react-router-dom";
import { useAppSelector } from "../hooks/reduxHooks";
//material-ui
import { Button } from "@mui/material";

function PageButtons() {
	const pageButtons = useAppSelector((state) => state.layout.pageButtons);
	//			<IconButton color="inherit">{pageBtn?.iconName}</IconButton>
	return (
		<div style={{ marginLeft: "auto", display: "flex", flexDirection: "row-reverse" }}>
			{pageButtons?.map((pageBtn: PageButton, i: number) =>
				pageBtn.disabled ? null : pageBtn.link ? (
					<Link key={pageBtn.key} to={pageBtn.link} title={pageBtn.label} style={{ whiteSpace: "nowrap", marginLeft: "0.5rem", textDecoration: "none" }}>
						<Button size="small" color={pageBtn.active ? "secondary" : "primary"} variant="contained" key={pageBtn.key} title={pageBtn.label}>
							{pageBtn.label}
						</Button>
					</Link>
				) : pageBtn.label ? (
					<Button
						style={{ whiteSpace: "nowrap", marginLeft: "0.5rem" }}
						size="small"
						color={pageBtn.active ? "primary" : "secondary"}
						variant="contained"
						key={pageBtn.key}
						title={pageBtn.label}
					>
						{pageBtn.label}
					</Button>
				) : null
			)}
		</div>
	);
}

export default PageButtons;
